import { AuthRequest, TokenManager } from '../../../../services/Auth';

const Logout = () => {
    TokenManager.destroy();
    return window.location.href = AuthRequest.getAuthRedirectUrl();
};

export default Logout;
